/* eslint-disable arrow-body-style */
import _ from 'underscore';

export const getFinalUrlStyles = ({ styleOverrides }) => () => {
  return {
    finalUrl: _.extend({
    }, styleOverrides.finalUrl),
  };
};
